import { defaultKeymap } from '@codemirror/commands';
import { keymap } from '@uiw/react-codemirror';

export const customKeyMap = keymap.of([
  ...defaultKeymap,
  {
    key: 'Ctrl-Enter',
    run: () => true
  }
]);
